import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { chMedicationRelationsByDiagnosisCodeQuery } from "@/modules/patients/detail/medication/ch/services/__generated__/chMedicationRelationsByDiagnosisCodeQuery.graphql"

const query = graphql`
  query chMedicationRelationsByDiagnosisCodeQuery($patientId: ID!, $diagnosisCode: String!, $appointmentId: ID!) {
    ch_medicationRelationsByDiagnosisCode(
      patientId: $patientId
      diagnosisCode: $diagnosisCode
      appointmentId: $appointmentId
    ) {
      medicationName
      medicationTemplateId
      pharmacode
    }
  }
`

export const useChMedicationRelationsByDiagnosisCode = (
  patientId: string,
  diagnosisCode: string,
  appointmentId: string,
) => {
  return useLazyLoadQuery<chMedicationRelationsByDiagnosisCodeQuery>(
    query,
    {
      patientId,
      diagnosisCode,
      appointmentId,
    },
    { fetchPolicy: "store-or-network" },
  )
}
